import { render, staticRenderFns } from "./accomodationList.vue?vue&type=template&id=c435333a&scoped=true&"
import script from "./accomodationList.vue?vue&type=script&lang=js&"
export * from "./accomodationList.vue?vue&type=script&lang=js&"
import style0 from "./accomodationList.vue?vue&type=style&index=0&id=c435333a&scoped=true&lang=css&"
import style1 from "./accomodationList.vue?vue&type=style&index=1&id=c435333a&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c435333a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c435333a')) {
      api.createRecord('c435333a', component.options)
    } else {
      api.reload('c435333a', component.options)
    }
    module.hot.accept("./accomodationList.vue?vue&type=template&id=c435333a&scoped=true&", function () {
      api.rerender('c435333a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accomodation/accomodationList.vue"
export default component.exports